import axios from "axios";
function getHeapUserId() {
    const heapUserId = heap === null || heap === void 0 ? void 0 : heap.userId;
    if (heapUserId) {
        return heapUserId;
    }
    else {
        console.warn("Heap not ready - cannot get heapUserId");
        return undefined;
    }
}
export function apiConfig(params) {
    const defaultTransformResponses = axios.defaults.transformResponse
        ? axios.defaults.transformResponse instanceof Array
            ? axios.defaults.transformResponse
            : [axios.defaults.transformResponse]
        : [];
    return {
        headers: {
            "Content-Type": "application/json",
            "x-heap-user-id": getHeapUserId(),
            "x-heap-session-id": heap === null || heap === void 0 ? void 0 : heap.getSessionId(),
        },
        params: params !== null && params !== void 0 ? params : {},
        transformResponse: [
            ...defaultTransformResponses,
            (data) => {
                if (data === "")
                    return null;
                return data;
            },
        ],
    };
}
export function authenticatedApiConfig(authenticationProvider, params) {
    const config = apiConfig(params);
    const token = authenticationProvider.token;
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}
export function generateURL(baseUrl, path, parameters) {
    let fullUrl = baseUrl + path;
    if (parameters) {
        Object.entries(parameters).forEach(([param, value]) => {
            fullUrl = fullUrl.replace(`:${param}`, value.toString());
        });
    }
    return fullUrl;
}
